"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _GenericStore2 = _interopRequireDefault(require("../../../Stores/GenericStore"));

var _AppNativeStorage = _interopRequireDefault(require("../../../../utils/AppNativeStorage"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var RELEVANCE_STORE_PATHS = {
  AVAILABLE_ASPECTS: 'availableAspects',
  CURRENT_ASPECT: 'currentAspect',
  RELEVANCES: 'relevances'
};

var RelevancesStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(RelevancesStore, _GenericStore);

  var _super = _createSuper(RelevancesStore);

  function RelevancesStore() {
    (0, _classCallCheck2["default"])(this, RelevancesStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RelevancesStore, [{
    key: "initialState",
    value: function initialState() {
      var _ref;

      return _ref = {}, (0, _defineProperty3["default"])(_ref, RELEVANCE_STORE_PATHS.AVAILABLE_ASPECTS, []), (0, _defineProperty3["default"])(_ref, RELEVANCE_STORE_PATHS.CURRENT_ASPECT, null), (0, _defineProperty3["default"])(_ref, RELEVANCE_STORE_PATHS.RELEVANCES, {}), _ref;
    }
  }, {
    key: "initFromPersistentStore",
    value: function () {
      var _initFromPersistentStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _updatedState, updatedState;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _updatedState = {};
                _context.t0 = _defineProperty3["default"];
                _context.t1 = _updatedState;
                _context.t2 = RELEVANCE_STORE_PATHS.CURRENT_ASPECT;
                _context.next = 7;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.CURRENT_ASPECT);

              case 7:
                _context.t3 = _context.sent;
                (0, _context.t0)(_context.t1, _context.t2, _context.t3);
                _context.t4 = _defineProperty3["default"];
                _context.t5 = _updatedState;
                _context.t6 = RELEVANCE_STORE_PATHS.AVAILABLE_ASPECTS;
                _context.next = 14;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.ASPECTS);

              case 14:
                _context.t7 = _context.sent;
                (0, _context.t4)(_context.t5, _context.t6, _context.t7);
                _context.t8 = _defineProperty3["default"];
                _context.t9 = _updatedState;
                _context.t10 = RELEVANCE_STORE_PATHS.RELEVANCES;
                _context.next = 21;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.RELEVANCES);

              case 21:
                _context.t11 = _context.sent;
                (0, _context.t8)(_context.t9, _context.t10, _context.t11);
                updatedState = _updatedState;
                this.setValues(updatedState);
                return _context.abrupt("return", _promise["default"].resolve());

              case 28:
                _context.prev = 28;
                _context.t12 = _context["catch"](0);
                return _context.abrupt("return", _promise["default"].reject(_context.t12));

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 28]]);
      }));

      function initFromPersistentStore() {
        return _initFromPersistentStore.apply(this, arguments);
      }

      return initFromPersistentStore;
    }()
  }, {
    key: "removeAspectsExcept",
    value: function removeAspectsExcept(keptAspects) {
      var updatedState = _objectSpread({}, this.state.relevances);

      (0, _keys["default"])(updatedState).forEach(function (key) {
        if (keptAspects.includes(key)) {
          delete updatedState.relevances[key];
        }
      });
    }
  }, {
    key: "setAvailableAspects",
    value: function setAvailableAspects(availableAspects) {
      console.log('RelevancesStore - onSetAvailableAspects', availableAspects);

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.ASPECTS, availableAspects);

      this.setValue(RELEVANCE_STORE_PATHS.AVAILABLE_ASPECTS, availableAspects);
    }
  }, {
    key: "setAvailableAspectsAndRelevances",
    value: function setAvailableAspectsAndRelevances(availableAspects, relevances) {
      var _updatedState2;

      console.log('RelevancesStore - onSetAvailableAspectsAndRelevances', availableAspects, relevances);

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.ASPECTS, availableAspects);

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.RELEVANCES, relevances);

      var updatedState = (_updatedState2 = {}, (0, _defineProperty3["default"])(_updatedState2, RELEVANCE_STORE_PATHS.AVAILABLE_ASPECTS, availableAspects), (0, _defineProperty3["default"])(_updatedState2, RELEVANCE_STORE_PATHS.RELEVANCES, relevances), _updatedState2);
      this.setValues(updatedState);
    }
  }, {
    key: "setCurrentAspect",
    value: function setCurrentAspect(aspect) {
      console.log('RelevancesStore - onSetCurrentAspect', aspect);

      _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.CURRENT_ASPECT, aspect);

      this.setValue(RELEVANCE_STORE_PATHS.CURRENT_ASPECT, aspect);
    }
  }]);
  return RelevancesStore;
}(_GenericStore2["default"]);

var relevanceStore = new RelevancesStore();
var _default = relevanceStore;
exports["default"] = _default;